import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import '../CallForSpeakers.scss';

const FormDetail = ({ fieldName, fields }) => {
  const fieldValue =
    fieldName === 'stream'
      ? fields[fieldName].value.toString().replace(/,/g, ', ')
      : fields[fieldName].value;
  const basicField = (
    <>
      <div key={fieldName} className="columns">
        <div className="column is-3 field-label">
          <strong>{fields[fieldName].label}</strong>
        </div>
        <div className="column is-9">{fieldValue}</div>
      </div>
    </>
  );

  if (fieldName === 'speakers') {
    return fields.speakers.map(speaker => (
      <Fragment key={speaker.id}>
        <div className="is-divider custom-divider" data-content="Speaker detail" />
        <div className="columns">
          <div className="column is-3 field-label">
            <strong>{speaker.speakerName.label}</strong>
          </div>
          <div className="column is-9">{speaker.speakerName.value}</div>
        </div>
        <div className="columns">
          <div className="column is-3 field-label">
            <strong>{speaker.email.label}</strong>
          </div>
          <div className="column is-9">{speaker.email.value}</div>
        </div>
        <div className="columns">
          <div className="column is-3 field-label">
            <strong>{speaker.company.label}</strong>
          </div>
          <div className="column is-9">{speaker.company.value}</div>
        </div>
        <div className="columns">
          <div className="column is-3 field-label">
            <strong>{speaker.country.label}</strong>
          </div>
          <div className="column is-9">{speaker.country.value}</div>
        </div>
        <div className="columns">
          <div className="column is-3 field-label">
            <strong>{speaker.speakerBio.label}</strong>
          </div>
          <div className="column is-9">{speaker.speakerBio.value}</div>
        </div>
        <div className="columns">
          <div className="column is-3 field-label">
            <strong>{speaker.photo.label}</strong>
          </div>
          <div className="column is-9">
            <img alt="" src={speaker.photo.value.image} />
          </div>
        </div>
      </Fragment>
    ));
  }

  if (fieldName === 'talkTitle') {
    return (
      <>
        <div className="is-divider custom-divider" data-content="Talk detail" />
        {basicField}
      </>
    );
  }

  if (fieldName === 'twitterPromotion') {
    return (
      <>
        <div className="is-divider custom-divider" data-content="Social" />
        {basicField}
      </>
    );
  }

  return basicField;
};

const CFSSummary = ({ fields }) => (
  <div className="summary" id="summary">
    <div>
      {Object.keys(fields).map(field => {
        let fieldRow;
        if (field === 'disclaimer') {
          fieldRow = (
            <div key={field} className="columns">
              <div className="column is-3 field-label">
                <strong>Disclaimer accepted</strong>
              </div>
              <div className="column is-9 disclaimer">Yes</div>
            </div>
          );
        } else if (field === 'videoDisclaimer') {
          fieldRow = (
            <div key={field} className="columns">
              <div className="column is-3 field-label">
                <strong>Recording disclaimer accepted</strong>
              </div>
              <div className="column is-9 disclaimer">Yes</div>
            </div>
          );
        } else {
          fieldRow = <FormDetail key={field} fieldName={field} fields={fields} />;
        }

        return fieldRow;
      })}
    </div>
  </div>
);

CFSSummary.propTypes = {
  // eslint-disable-next-line
  fields: PropTypes.object.isRequired
};

export default CFSSummary;
